import { normalize, schema } from 'normalizr';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const BABIES_LIST_SUCCESS = api.events.babiesList.actionSuccess;
const BABIES_PATCH_SUCCESS = api.events.babiesPatch.actionSuccess;
const BABIES_CREATE_SUCCESS = api.events.babiesCreate.actionSuccess;
const babySchema = new schema.Entity('babies');

const babyListSchema = new schema.Array(babySchema);

const defaultState = {};

export default function(state = defaultState, action) {
  switch (action.type) {
    case BABIES_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, babyListSchema);

      return {
        ...normalizedData.entities.babies
      };
    }
    case BABIES_PATCH_SUCCESS: {
      const baby = action.data;
      return {
        ...state,
        [baby.id]: baby
      };
    }
    case BABIES_CREATE_SUCCESS: {
      const baby = action.data;
      return {
        ...state,
        [baby.id]: baby
      };
    }
    case LOGOUT_SUCCESS: {
      return defaultState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/babies.js